// extracted by mini-css-extract-plugin
export var container = "_cq-0";
export var infoIcon = "_cq-2";
export var titleRowCol = "_cq-1";